import { EvtHeader } from "components/header";
import JobForm from "@/modules/work/jobs/form";
import { useJob } from "@/modules/work/jobs/context";

const UpdateJob = () => {
  const { config } = useJob();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Job" />
      <div className="p-6 max-w-md">
        <JobForm config={config} />
      </div>
    </div>
  );
};

export default UpdateJob;
